// The app page a user was on before opening support, so a new ticket can say
// where the problem is ("📍 /timetable" on the staff card) without the user
// having to type it.
//
// BaseLayout records every non-support location; the new-ticket form reads it.
// sessionStorage rather than router state: state is lost on a refresh and on
// the list → new hop, which is exactly the path most tickets take.
const KEY = "support.originPath";

export function rememberSupportOrigin(path) {
  if (!path || path.startsWith("/support")) return;
  try {
    sessionStorage.setItem(KEY, path.slice(0, 500));
  } catch (_e) {
    /* storage can throw in private windows; the hint is optional */
  }
}

export function readSupportOrigin() {
  try {
    const value = sessionStorage.getItem(KEY) || "";
    // Only ever an in-app path — the server refuses anything else.
    return value.startsWith("/") && !value.startsWith("//") ? value : "";
  } catch (_e) {
    return "";
  }
}
